import { useRouter } from "next/router";
import { useSelector } from "react-redux";

import {
  getSignInUrlWithoutReturnUrl,
  getSignOutUrlWithoutReturnUrl,
  getSignUpUrlWithoutReturnUrl,
} from "redux/selectors/config";

import useDomain from "./useDomain";

type SsoUrls = {
  signInUrl: string;
  signOutUrl: string;
  signUpUrl: string;
};

export const useSsoUrls = (
  signInQueryString?: string,
  signUpQueryString?: string,
  signOutQueryString?: string
): SsoUrls => {
  const domain = useDomain();
  const { asPath } = useRouter();
  const signInPath = signInQueryString
    ? asPath.indexOf("?") > -1
      ? `${asPath}&${signInQueryString}`
      : `${asPath}?${signInQueryString}`
    : asPath;
  const signInReturnUrl = `${domain}${signInPath}`;
  const signUpPath = signUpQueryString
    ? asPath.indexOf("?") > -1
      ? `${asPath}&${signUpQueryString}`
      : `${asPath}?${signUpQueryString}`
    : asPath;
  const signOutPath = signOutQueryString
    ? asPath.indexOf("?") > -1
      ? `${asPath}&${signOutQueryString}`
      : `${asPath}?${signOutQueryString}`
    : asPath;
  const signUpRetunUrl = `${domain}${signUpPath}`;
  const signOutReturnUrl = `${domain}${signOutPath}`;
  const signInUrlWithoutReturnUrl = useSelector(getSignInUrlWithoutReturnUrl);
  const signUpUrlWithoutReturnUrl = useSelector(getSignUpUrlWithoutReturnUrl);
  const signOutUrlWithoutReturnUrl = useSelector(getSignOutUrlWithoutReturnUrl);
  return {
    signInUrl: `${signInUrlWithoutReturnUrl}${encodeURIComponent(
      signInReturnUrl
    )}`,
    signOutUrl: `${signOutUrlWithoutReturnUrl}${encodeURIComponent(
      signOutReturnUrl
    )}`,
    signUpUrl: `${signUpUrlWithoutReturnUrl}${encodeURIComponent(
      signUpRetunUrl
    )}`,
  };
};
